import { render, staticRenderFns } from "./IconVinkjeAppendix.vue?vue&type=template&id=720e9676"
import script from "./IconVinkjeAppendix.vue?vue&type=script&lang=ts"
export * from "./IconVinkjeAppendix.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports